import { render } from "./SearchDemand.vue?vue&type=template&id=2f861e48"
import script from "./SearchDemand.vue?vue&type=script&lang=js"
export * from "./SearchDemand.vue?vue&type=script&lang=js"

import "./SearchDemand.vue?vue&type=style&index=0&id=2f861e48&lang=css"

import exportComponent from "/home/webcoom/Documents/www/esim-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__